import { Label, Tooltip, UIHeading4, UIText2 } from '@cian/ui-kit';

import { type FC } from 'react';

import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors';
import { useCAForCard } from '@/microfrontends/listing/shared/hooks/card/useCAForCard';

import { stopPropagation } from '@/packages/utils/event/stopPropagation';

import { TooltipContent } from '../../components/TooltipContent';

export const BestPlaceAnalyticsLabelContainer: FC = () => {
  const { url } = useCardOfferDataContext();
  const ca = useCAForCard();

  return (
    <a
      data-testid="publisher-labels.best-place"
      href={`${url}/?with_best_place=1`}
      rel="noreferrer"
      style={{ textDecoration: 'none' }}
      target="_blank"
      onClick={e => {
        e.stopPropagation();
        ca({ action: 'click_buy_report', category: 'Listing', label: 'geoanalytics_popup' });
      }}
    >
      <Tooltip
        arrow={false}
        placement="bottom"
        theme="white"
        title={
          <TooltipContent onClick={stopPropagation}>
            <UIHeading4>Оцените привлекательность объекта</UIHeading4>
            <UIText2>Узнайте, насколько помещение и район подходят для вашего бизнеса</UIText2>
          </TooltipContent>
        }
      >
        <Label background="surface-main-default" color="accent-main-primary">
          Отчёт по объекту
        </Label>
      </Tooltip>
    </a>
  );
};
